import React from "react";
import { Skeleton } from "@/components/atoms/Skeleton";

export const VendorProfileSkeletonCard = () => {
  return (
    <div
      className="md:tw-flex tw-gap-32 tw-w-full"
      aria-label="Loading vendor information"
    >
      <Skeleton
        width={256}
        height={205}
        borderRadius="4px"
        classNames="tw-shrink-0 tw-bg-gray-200"
      />
      <div className="tw-flex tw-flex-col tw-gap-12 tw-w-full tw-my-20">
        <Skeleton height={24} width="60%" classNames="tw-bg-gray-200" />
        <Skeleton height={12} width="40%" classNames="tw-bg-gray-200" />
        <Skeleton height={12} width="50%" classNames="tw-bg-gray-200" />
        <div className="tw-flex tw-flex-col tw-gap-8 tw-mt-8">
          <Skeleton height={12} width="70%" classNames="tw-bg-gray-200" />
          <Skeleton height={12} width="80%" classNames="tw-bg-gray-200" />
          <Skeleton height={12} width="80%" classNames="tw-bg-gray-200" />
          <Skeleton height={12} width="60%" classNames="tw-bg-gray-200" />
        </div>
      </div>
    </div>
  );
};
